import React from 'react';
import Loader from '../common/Loader';
import { useFetch } from '../data/fetch/useFetch';
import { parseWidgetData } from '../data/parseWidgetData';
import { getConfiguration } from '../data/utils/configuration';
import TournamentEvent from '../prematch/TournamentEvent';
import MatchHeader from './MatchHeader';

export default function TopMatches() {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );

    if (isLoading || isError) {
        return <Loader error={isError} />;
    }

    const matchesByType = new Map();
    data.topMatches.forEach(match => {
        const matchBet = match.bets[0].id;
        const uniqueItemId = `${match.sportRef}_${match.tournamentRef}_${matchBet}`;
        if (!matchesByType.has(uniqueItemId)) {
            matchesByType.set(uniqueItemId, []);
        }
        matchesByType.get(uniqueItemId).push(match);
    });
    const items = Array.from(matchesByType.values());
    
    return (
        <div className="l_3 topMatches-wrapper">
            {items.map((matches, i) => {
                const firstMatch = matches[0];
                return (
                    <MatchHeader key={i} match={firstMatch} toggled={true}>
                        {matches.map(match =>
                            <TournamentEvent key={match.id} data={match} />
                        )}
                    </MatchHeader>
                );
            })}
        </div>
    );
}
